import { IdStyles } from "../less/IdStyles";
import { utilArray } from "./utilArray";
var UtilIcons = /** @class */ (function () {
    function UtilIcons() {
        var _this = this;
        this.iconSizes = [
            IdStyles.IconSmall,
            IdStyles.IconMedium,
            IdStyles.IconLarge,
            IdStyles.IconExtraLarge,
        ];
        this.previousIconSize = function (styleId) {
            var index = _this.getMatchingIndex(styleId) - 1;
            utilArray.adjustIndexToBoundaries(index, _this.iconSizes);
            return _this.iconSizes[index];
        };
        this.nextIconSize = function (styleId) {
            var index = _this.getMatchingIndex(styleId) + 1;
            utilArray.adjustIndexToBoundaries(index, _this.iconSizes);
            return _this.iconSizes[index];
        };
        this.getMatchingIndex = function (styleId) {
            return _this.iconSizes.findIndex(function (element) { return element === styleId; });
        };
    }
    return UtilIcons;
}());
export var utilIcons = new UtilIcons();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilIcons.ts
// module id = 1137
// module chunks = 3